import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=3ddc8ea0&scoped=true&lang=html&"
import script from "./Content.vue?vue&type=script&lang=ts&"
export * from "./Content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc8ea0",
  null
  
)

export default component.exports